import axios from './axios';

export default class LabFeedback {
  static async create(data) {
    const response = await axios.post('/analytics/lab_feedback', data);
    return response.data;
  }
}
